// extracted by mini-css-extract-plugin
export default {"footer":"jEJ9D1UZ7NPddMa","button":"Y8OiiNbTUIKWycH","button-mobile":"vLyhB0FcTD3JnvX"};